module.exports = __webpack_public_path__ + "img/governance.6fbdf28d.svg";